<template>
<div class="chapter">
<div class="inner_page">
<p class="p1">For Piper Vaughn, who asked for Justin’s story straight after reading <span class="t2">A Bar Tender Tale</span> and poked me about it until I finally relented. This one’s for you! Enjoy!</p>
<p class="p2"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?176e7bf6